<template>
  <Layout buy-button-class="btn-default btn-small">
    <div class="rwt-video-popup-area rn-section-gap">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <SectionTitle
                text-align="center"
                subtitle="Installation Tutorial"
            />
          </div>
        </div>
        <Video :video-data="videoData"/>
      </div>
    </div>
    <template v-for="(module, index) of modules">
      <div :key="`module${index}`" v-if="module.type === '幻灯片'" class="slider-area slider-style-4 slider-dot rn-slick-dot rn-slick-arrow">
        <VueSlickCarousel v-bind="sliderSetting">
          <div v-for="(slider, i) in module.content.list" :key="i" class="single-slide">
            <div class="height-950 bg-overlay bg_image"
                 :style="{'background-image': `url(${slider.image})`}">
              <div class="container">
                <div class="row row--30 align-items-center">
                  <div class="col-12">
                    <div class="inner text-center">
                      <h1 class="title" v-html="slider.title"/>
                      <p class="description" v-html="slider.subtitle"/>
                      <div class="button-group mt--30">
                        <router-link class="btn-default"
                           :to="{ name: 'ProductDetail', params: { asin: slider.asin.asin }, query: $route.query }">
                          {{ slider.text }}
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </VueSlickCarousel>
      </div>
      <div :key="`module${index}`" v-if="module.type === '商品列表'"  class="rwt-portfolio-area rn-section-gap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <SectionTitle
                  text-align="center"
                  :subtitle="module.content.title"
                  :title="module.content.subtitle"
                  data-aos="fade-up"
                  data-aos-delay="60"
              />
            </div>
          </div>
          <simple-portfolio class="mt--20" :portfolio-data="module.content.list"
                            column="col-lg-3 col-6 mt--30"/>
        </div>
      </div>
      <div :key="`module${index}`" v-if="module.type === '用户评论'" class="rwt-testimonial-area rn-section-gap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <SectionTitle
                  text-align="center"
                  :subtitle="module.content.title"
                  :title="module.content.subtitle"
                  description="We provide company and finance service for <br /> startups and company business."
                  data-aos="fade-up"
              />
            </div>
          </div>
          <div class="row row--15">
            <div class="col-lg-4 col-md-6 col-12 mt--30"
                 v-for="(testimonial, index) in module.content.list"
                 :key="index">
              <Testimonial :testimonial="testimonial"/>
            </div>
          </div>
        </div>
      </div>
      <div  :key="`module${index}`" v-if="module.type === '单品展示'" class="rwt-split-area rn-section-gap">
        <div class="container">
          <Split :split-data="module.content"/>
        </div>
      </div>
      <Separator/>
    </template>
  </Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import SectionTitle from '@/components/elements/sectionTitle/SectionTitle'
import VueSlickCarousel from 'vue-slick-carousel'
import Testimonial from '@/components/elements/testimonial/Testimonial'
import SimplePortfolio from '@/components/elements/portfolio/SimplePortfolio'
import Split from '@/components/elements/split/Split'
import site from '@/data/site.json'
import Video from '@/components/elements/video/Video.vue'

export default {
  name: 'HomePage',
  components: { Layout, Separator, SectionTitle, VueSlickCarousel, Testimonial, SimplePortfolio, Split , Video },
  data() {
    return {
      modules: site.modules,
      sliderSetting: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 993,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      },
      videoData: [
        {
          thumb: require(`@/assets/images/cover.png`),
          src: 'https://www.youtube.com/watch?v=HpNMK2wh4S4',
        },
      ]
    }
  }
}
</script>
